import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import ListaClientes from "../../Componentes/ListaClientes";
import FiltroServico from "../../Componentes/FiltroServico";
import { useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import "./styles.css";

const Menu = () => {
  const { resetaVariaveis } = usePentagovContext();
  const { isAuthenticated, authReady, } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();
  const navigate = useNavigate();
  const [Clientes, setClientes] = useState([]);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);

  let idFormatado = String(IDOperador).padStart(6, '0');

  useEffect(() => {
    if (operador && operador.IDOperador && isAuthenticated && authReady) {
      inicializaTela(processoSelecionado);
    } else {
      navigate("/");
    }
  }, [operador, processoSelecionado]);

  
  async function inicializaTela(processo = null) {
    resetaVariaveis();

    const retorno = await buscaClientes(IDOperador, processo);

    if (retorno && retorno.data && Array.isArray(retorno.data.Clientes)) {
      setClientes(retorno.data.Clientes);
    } else {
      console.warn("Clientes não encontrados ou estrutura inesperada:", retorno.data);
      setClientes([]);
    }
  }


  async function buscaClientes(IDOperador, processo) {
    try {
      let url = `/clientes/operador/${IDOperador}`;

      if (processo && processo.trim() !== '') {
        url += `/${processo}`;
      }

      const response = await api.get(url);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />
        <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>CLIENTES</h4>
        
        <FiltroServico
          valorSelecionado={processoSelecionado}
          onChange={setProcessoSelecionado}
        />

        <ListaClientes lista={Clientes || []} />

      </div>
    </div>

  );
};

export default Menu;